export default "__VITE_ASSET__TUy90zsn__"